import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const reinviteDepositorApi = (wireId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/depositor/reinvite/`;

  return authApiService.POST(uri, {});
};
